import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ProcessDataSource } from 'src/app/services/process.datasource';
import { ProcessService } from 'src/app/services/process.service';
import { UserService } from 'src/app/services/user.service';
import { YearService } from 'src/app/services/year.service';
import { environment } from "../../../../environments/environment";
@Component({
  selector: 'rdf-stat-table',
  templateUrl: './stat-table.component.html',
  styleUrls: ['./stat-table.component.css']
})
export class StatTableComponent implements OnInit {
  dataSource: ProcessDataSource
  @Input() displayedColumns;
  @Output() onDownloadStatistics = new EventEmitter<any>();
  displayedYears = []
  user: any;
  name: string;
  objectFilter = {internal : false}
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  currentYear = new Date().getFullYear().toString()

  constructor(public yearService: YearService,
    public translate: TranslateService,
    private router: Router,
    public processService: ProcessService, public userService: UserService, public spinner: NgxSpinnerService) { 
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user
      this.dataSource = new ProcessDataSource(this.processService)
      this.yearService.getList("year").subscribe(val => {
        val.forEach(element => {
          this.displayedYears.push(element.year)
        });
        if (val.length > 0) {
          setTimeout(() => {
            this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
            merge(this.sort.sortChange, this.paginator.page)
              .pipe(
                tap(() => this.loadProcessPage())
              )
              .subscribe();
          }, 1000)
        }
      });
    })
  }

  ngOnInit() {
  }

  advancedSearch(filter) {
    this.spinner.show()
    this.objectFilter = filter
    this.objectFilter['internal'] = false
    this.loadProcessPage()
  }

  getGovinLink(id,username) {
    return environment.govinLink + '/process/'+id+'?token_from_tas=' + localStorage.getItem(environment.accessToken) + '&username=' + username
  }
  canGoToGovin() {
    if (this.user) {
      return !['MAYOR_TREASURER', 'CENTRAL_READER'].includes(this.user.role)
    }
    return false
  }

  goToStatDetails(row) {
    this.router.navigate(['stat_details'], { queryParams: { dec_key: row.key, dec_name: row.name, dec_year: this.currentYear } });
  }
  downloadStatistics() {
    let extraData = {
      statuses: {
        submitted: this.translate.instant("DECLARATIONS.SUBMITTED"),
        inProgress: this.translate.instant("DECLARATIONS.INPROGRESS")
      },
      headers: [
        { header: this.translate.instant('PROCESS.TAX_ID'), key: 'username' },
        { header: this.translate.instant('PROCESS.COMPANY_NAME'), key: 'companyName' },
        { header: this.translate.instant("PROCESS.NAME"), key: 'name' },
        { header: this.translate.instant("PROCESS.STATUS"), key: 'status' },
        { header: this.translate.instant("PROCESS.DUE_DATE"), key: 'due_date' },
        { header: this.translate.instant("PROCESS.STARTED_ON"), key: 'started_on' },
        { header: this.translate.instant("PROCESS.LAST_MODIFIED"), key: 'last_modified' },
        { header: this.translate.instant("PROCESS.PERIOD"), key: 'month' },
      ],
      "1": this.translate.instant('STATISTICS.MON_1'),
      "2": this.translate.instant('STATISTICS.MON_2'),
      "3": this.translate.instant('STATISTICS.MON_3'),
      "4": this.translate.instant('STATISTICS.MON_4'),
      "5": this.translate.instant('STATISTICS.MON_5'),
      "6": this.translate.instant('STATISTICS.MON_6'),
      "7": this.translate.instant('STATISTICS.MON_7'),
      "8": this.translate.instant('STATISTICS.MON_8'),
      "9": this.translate.instant('STATISTICS.MON_9'),
      "10": this.translate.instant('STATISTICS.MON_10'),
      "11": this.translate.instant('STATISTICS.MON_11'),
      "12": this.translate.instant('STATISTICS.MON_12'),
    }
    this.spinner.show();
    this.processService.downloadList(this.objectFilter, extraData, ).subscribe
      (data => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = 'document_' + Date.now() + '.xlsx';
        saveAs(file, filename);
      });
  }

  loadProcessPage() {
    this.dataSource.loadProcesses(null, '', this.sort.direction, this.sort.active, this.paginator.pageIndex, this.paginator.pageSize, this.objectFilter, this.spinner);
  }
}
